// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2RxEu","label":"Labeled_label__2l6KG","divider":"Labeled_divider__37-QP"};